import styled from 'styled-components';

export default styled.div`
  .modal-loading-wrap {
    display: flex;
    justify-content: center;
  }
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    align-items: flex-start;
    &--infos {
      padding: 10px 0 15px 0;
      width: 100%;
      display: flex;
      div {
        margin-right: 10px;
        p {
          margin-right: 5px;
        }
      }
    }
    h2,
    p {
      max-width: 100%;
    }
  }
  .documents-wrap {
    padding-top: 20px;
    &--items-wrap {
      padding-top: 10px;
      display: flex;
      flex-flow: row wrap;
      width: 100%;
      .document {
        margin-top: 10px;
        border: none;
        background: none;
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 50%;
        padding-right: 20px;
        &:hover {
          opacity: 0.8;
        }
        &:hover,
        &:active,
        &:focus {
          outline: none;
          box-shadow: none;
        }
        svg {
          min-width: 26px;
          max-width: 26px;
        }
        small {
          word-break: break-all;
          text-align: left;
          padding-left: 10px;
        }
      }
    }
  }
`;
